<template>
  <div class="list-wrapper-legalPerson">
    <RadioGroup v-model="radioName" v-if="showList.length" @on-change="select">
      <Radio class="flex" :label="item.id" v-for="item in showList" :key="item.id">
       &nbsp;<span>{{ item.partnerName }}</span>
      </Radio>
    </RadioGroup>
  </div>
</template>

<script>
import { RadioGroup, Radio} from 'view-ui-plus'

export default {
  name: "List",
  components: { Radio, RadioGroup  },
  data(){
    return{
      radioName: '',
      showList: []
    }
  },
  props: {
    list: Array,
    show: Boolean,
    keyword: String
  },
  methods: {
    select(item) {
      const resItem = this.list.find(its => its.id === item)
      this.$emit('select', resItem)
    }
  },
  watch:{
    show(val){
      if (val) {
        this.$emit('clearKeyword')
        this.list.forEach(item => {
          if (item.checked) {
            this.radioName = item.id
          }
        })
        this.showList = this.list
      }
    },
    keyword(val){
      if (val) {
        this.showList = this.list.filter(item => item.partnerName.indexOf(val) > -1)
      } else {
        this.showList = this.list
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-wrapper-legalPerson {
  max-height: 400px;
  overflow: auto;
  margin-top: 10px;
  .ivu-radio-group {
    width: 100%;
    height: auto;
    max-height: 50vh;
    // overflow: auto;
    .ivu-radio-wrapper {
      width: 100%;
      padding: 10px 8px;
      font-size: 16px;
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      &:hover {
        background-color: #f5f7fa;
        transition: color 0.3s;
        color: #409eff;
      }
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
}
</style>
